import { useAuth } from "../../hooks/useAuth";
import styles from "./profileMenu.module.css";
import { UserProfileMenuConfig } from "../../../config/interactive/types";
import Focusable from "./Focusable";
import { eventUserProfileClicked, gaSetUserId } from "../../utils/gtag";

function ProfileMenu({ config }: { config: UserProfileMenuConfig }) {
	const { userProfile, isAuthenticated, platformAuth } = useAuth();

	if (!config.isUserProfile) return null;

	const picture = userProfile?.picture ?? "https://api.sbgtv.tech/assets/avatars/0034_v1.svg";

	const handleClick = () => {
		eventUserProfileClicked(isAuthenticated);
		// Login if the user is not
		if (!isAuthenticated) {
			platformAuth?.redirectUserToLogin("CABN");
			return;
		}

		// Otherwise just log the user out for now
		gaSetUserId(null);
		platformAuth?.logout();
	};

	return (
		<Focusable
			navigation={config.navigation}
			onClick={handleClick}
			className={styles.profileContainer}
		>
			<img src={picture} className={styles.profileImage} alt="Profile picture" />
			<div className={styles.profileText}>
				<h1>{userProfile?.username ?? "Guest"}</h1>
			</div>
		</Focusable>
	);
}

export default ProfileMenu;
